import { useEffect, useCallback, useMemo } from 'react';
import { useApiGet, useApiLoading } from 'react-reqq-lite';

import { useMerchantSelected } from 'core-modules/merchants/hooks';

import * as c from './contants';
import * as actions from './actions';

export const useGetApiKeyList = () => {
  const [, merchant] = useMerchantSelected();
  const isLoading = useApiLoading(c.MERCHANT_API_KEY_LIST, 'get');
  const data = useApiGet(c.MERCHANT_API_KEY_LIST, []);
  useEffect(() => {
    actions.getApiKeyList(merchant?.id);
  }, [merchant]);
  return [isLoading, data];
};

export const useApiKeyOptions = () => {
  const data = useApiGet(c.MERCHANT_API_KEY_LIST, []);
  const options = useMemo(
    () =>
      data.map((x) => ({
        label: x.api_type,
        value: x.api_key_id,
        data: x,
      })),
    [data]
  );
  return [options];
};

export const useApiKeyActiveInactive = () => {
  const isLoading = useApiLoading(c.MERCHANT_API_KEY, 'put');
  const activeInactive = useCallback(
    (merchantId, apiKeyId, status, onSuccess) => {
      actions.apiKeyActiveInactive(merchantId, apiKeyId, status, onSuccess);
    },
    []
  );
  return [isLoading, activeInactive];
};

export const useRegenerateApiKey = () => {
  const isLoading = useApiLoading(c.MERCHANT_API_KEY_REGENERATE, 'put');
  const regenerate = useCallback((merchantId, apiKeyId, onSuccess) => {
    actions.regenerateApiKey(merchantId, apiKeyId, onSuccess);
  }, []);
  return [isLoading, regenerate];
};

export const useUpdateApiKey = () => {
  const isLoading = useApiLoading(c.MERCHANT_API_KEY_ITEM, 'put');
  const update = useCallback((merchantId, apiKeyId, payload, onSuccess) => {
    actions.updateApiKey(merchantId, apiKeyId, payload, onSuccess);
  }, []);
  return [isLoading, update];
};
